import { createFileRoute } from '@tanstack/react-router'

import { Wizard } from '@/components/wizard/Wizard'

/**
 * Cadastro de uma área via wizard dinâmico.
 *
 * Qual definição usar não é escolha do cliente: o servidor resolve o formulário
 * vigente ao criar o rascunho. Enquanto o código vinha daqui, um bundle
 * desatualizado abria cadastro na definição errada — e o cadastro guarda para
 * sempre a versão que usou.
 */
function CadastroPage() {
  return <Wizard />
}

export const Route = createFileRoute('/_auth/cadastro')({ component: CadastroPage })
